import { CompleteEvaluationWizardTypes } from './types';
import Form from '@/common/Form';
import { QuestionnaireAttemptOverallResultEnum } from '@/models/gen/graphql';
import { ReactElement } from 'react';
import Textarea from '@/common/Textarea';
import { getClasses } from '@/utils';

const Step1 = (): ReactElement => (
  <div className="CompleteEvaluationWizard-Step">
    <div className="CompleteEvaluationWizard-SectionHeader">
      <i className="sv sv-clipboard-check CompleteEvaluationWizard-SectionIcon CompleteEvaluationWizard-SectionIcon-Notes" />
      <div>
        <h5>Field Notes &amp; Evidence</h5>
        <p>Add evaluation and supporting documentation</p>
      </div>
    </div>

    <div>
      <p className="CompleteEvaluationWizard-Label m-0">Field Notes</p>
      <Form.Field name="fieldNotes" className="CompleteEvaluationWizard-Field">
        <Form.Input
          name="fieldNotes"
          as={Textarea}
          validate
          rows={3}
          placeholder="Enter detailed observations, coaching provided, and any notable incidents."
        />
      </Form.Field>
      <p className="CompleteEvaluationWizard-HelperText">
        These notes will be included in the driver&apos;s permanent record and may be used for performance reviews.
      </p>
    </div>

    <div className="CompleteEvaluationWizard-Field">
      <p className="CompleteEvaluationWizard-Label">Overall Result</p>

      <Form.Watch name="overallResult">
        {([overallResult]: QuestionnaireAttemptOverallResultEnum[], { setValue, trigger }): ReactElement => (
          <>
            <Form.Field name="overallResult" className="OverallResultPills">
              {CompleteEvaluationWizardTypes.OPTIONS.map(({ value, color }) => {
                const checked = overallResult === value;
                return (
                  <Form.Button
                    type="button"
                    key={value}
                    variant="light"
                    className={getClasses('OverallResultPills-Pill', checked ? 'OverallResultPills-Pill-Checked' : undefined)}
                    style={{
                      color: checked ? '#fff' : color,
                      borderColor: color,
                      backgroundColor: checked ? color : undefined,
                    }}
                    onClick={(): void => {
                      setValue('overallResult', checked ? '' : value, { shouldDirty: true, shouldValidate: true });
                      trigger();
                    }}
                  >
                    {CompleteEvaluationWizardTypes.OverallResultLabel[value]}
                  </Form.Button>
                );
              })}
              <Form.Input name="overallResult" validate style={{ display: 'none' }} />
            </Form.Field>
            <p className="CompleteEvaluationWizard-HelperText">
              {CompleteEvaluationWizardTypes.OPTIONS.find((o) => o.value === overallResult)?.description}
            </p>
          </>
        )}
      </Form.Watch>
    </div>
  </div>
);

export default Step1;
